export enum HRNotificationType {
  ContractExpiration = 1,
  AccommodationGuestDurationExpiration = 2,
  Birthday = 3,
  AccommodationCheckInExpiration = 5,
  ContractTermination = 6,
  HrRequestSubmitted = 8,
  DocumentExpiration = 9,
  MissingWorkSchedule = 10,
}

export enum HrRequestType {
  AnnualLeave = 1,
  SickLeave = 2,
  UnpaidLeave = 3,
  DayOff = 4,
  ShiftChange = 5,
  Overtime = 6,
}

export enum HrRequestStatus {
  Pending = 1,
  Approved = 2,
  Rejected = 3,
  Cancelled = 4,
}

export enum UserDocumentCategory {
  Contract = 1,
  IDDocument = 2,
  WorkPermit = 3,
  Certificate = 4,
  Medical = 5,
  Training = 6,
  Other = 7,
}

export enum UserDocumentStatus {
  Pending = 1,
  Active = 2,
  Inactive = 3,
}
